import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
	url: process.env.REACT_APP_KC_HOST || '',
	realm: process.env.REACT_APP_KC_REALM || '',
	clientId: process.env.REACT_APP_KC_CLIENT_ID || '',
});

/** Лимит длины URL выхода: при превышении — 414 Request-URI Too Large. */
const LOGOUT_URL_SAFE_LENGTH = 6000;

function getKeycloakLogoutUrl(kc: Keycloak): string {
	const base = `${kc.authServerUrl}/realms/${kc.realm}/protocol/openid-connect/logout`;
	const params = new URLSearchParams({
		client_id: kc.clientId || '',
		post_logout_redirect_uri: `${window.location.origin}/login`,
	});
	return `${base}?${params.toString()}`;
}

/**
 * Выход из Keycloak. При большом числе групп id_token длинный → стандартный logout() даёт 414.
 * В этом случае используем короткий URL без id_token_hint.
 */
export function keycloakLogout(kc: Keycloak): void {
	const redirectUri = `${window.location.origin}/login`;
	const shortUrl = getKeycloakLogoutUrl(kc);
	const idToken = kc.idToken;
	const wouldBeLong = !idToken || shortUrl.length + idToken.length > LOGOUT_URL_SAFE_LENGTH;

	if (wouldBeLong) {
		window.location.href = shortUrl;
		return;
	}
	kc.logout({ redirectUri });
}

export default keycloak;
